import React, { useState } from 'react';
import { Col, Nav, Row, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';
import { TfiHelpAlt, TfiLock } from 'react-icons/tfi';
import { FaAngleRight } from 'react-icons/fa';
import './contactFormWidget.scss';

function ContactUsComponent() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';
    const [successMessage, setSuccessMessage] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        website: '',
        message: ''
    });

    const [userFormData, setUserFormData] = useState({
        username: '',
        password: ''
    });
    const [captchaValue, setCaptchaValue] = useState(null);

    // Function to update form state for both forms
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleUserChange = (e) => {
        setUserFormData({
            ...userFormData,
            [e.target.name]: e.target.value
        });
    };

    // Generic function for POST requests
    const postData = async (url, data) => {
        const formDatas = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            formDatas.append(key, value);
        });

        const response = await fetch(url, {
            method: 'POST',
            body: formDatas
        });
        return response.text(); // Updated to return text since PHP script outputs plain text responses
    };

    // Handle form submission for public (non-client) users
    const handleSubmitPublic = async (e) => {
        e.preventDefault();

        // Use relative URLs to local PHP files (eliminates CORS issues)
        const url = isFR ? '/assets/php/contact-mail_fr.php' : '/assets/php/contact-mail_en.php';

        if (!captchaValue) {
            alert('Please verify you are not a robot.');
            return;
        }

        try {
            const data = {
                ...formData,
                'g-recaptcha-response': captchaValue
            };
            const response = await postData(url, data);
            setSuccessMessage(response);
            setFormData({
                name: '',
                email: '',
                website: '',
                message: ''
            });
        } catch (error) {
            console.error('There was an error!', error);
        }
    };

    // Handle form submission for registered users
    const handleSubmitRegistered = async (e) => {
        e.preventDefault();
        const actionURL = `https://obambu.com/my/clientarea.php?language=${isFR ? 'french' : 'english'}&amp;systpl=${isFR ? 'fr' : 'en'}`;

        window.location.href = actionURL;
    };

    // Handler for reCAPTCHA
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    return (
        <section className="contact-section">
            <Row>
                <Col lg={7}>
                    <Tabs defaultActiveKey="user-form" id="contact-us-tabs">
                        <Tab eventKey="user-form" title={t('contact-page.contact-form-title-1')}>
                            <p>
                                {t('contact-page.contact-form-text-1')}{' '}
                                <strong>info@obambu.com.</strong>
                            </p>
                            <p>
                                {t('contact-page.contact-form-text-2')}
                                <br />
                                <br />
                            </p>
                            <form onSubmit={handleSubmitPublic}>
                                <Row>
                                    <Col md={12}>
                                        <Row>
                                            <Col md={6}>
                                                <div className="form-group">
                                                    <input
                                                        autoComplete="name"
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        placeholder={t(
                                                            'contact-page.contact-form-name'
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="form-group">
                                                    <input
                                                        autoComplete="email"
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        placeholder={t(
                                                            'contact-page.contact-form-email'
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        name="website"
                                                        value={formData.website}
                                                        onChange={handleChange}
                                                        placeholder={t(
                                                            'contact-page.contact-form-subject'
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <textarea
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                placeholder={t('contact-page.contact-form-message')}
                                            />
                                        </div>
                                    </Col>
                                    <div className="captcha-wrapper">
                                        <ReCAPTCHA
                                            sitekey="6LdIZdkZAAAAAB3FufE2MCsuMYg7feC5-u6qa1ps"
                                            onChange={handleCaptchaChange}
                                        />
                                    </div>
                                    <div className="submit-button">
                                        <button type="submit">
                                            {t('contact-page.contact-form-send')}
                                        </button>
                                        {successMessage ? (
                                            <p className="contact-send-message success">
                                                {successMessage}
                                            </p>
                                        ) : null}
                                    </div>
                                </Row>
                            </form>
                        </Tab>
                        <Tab eventKey="login-form" title={t('contact-page.contact-form-title-2')}>
                            <p>
                                {t('contact-page.contact-form-text-3')}
                                <br />
                                <br />
                            </p>
                            <form onSubmit={handleSubmitRegistered}>
                                <Row>
                                    <Col md={12}>
                                        <Row>
                                            <Col md={6}>
                                                <div className="form-group">
                                                    <input
                                                        autoComplete="email"
                                                        type="email"
                                                        name="username"
                                                        value={userFormData.username}
                                                        onChange={handleUserChange}
                                                        placeholder={t(
                                                            'contact-page.contact-form-email-address'
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="form-group">
                                                    <input
                                                        autoComplete="current-password"
                                                        type="password"
                                                        name="password"
                                                        value={userFormData.password}
                                                        onChange={handleUserChange}
                                                        placeholder={t(
                                                            'contact-page.contact-form-password'
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="submit-button">
                                            <button type="submit">
                                                {t('contact-page.contact-form-login')}
                                            </button>
                                        </div>
                                        <p className="safe-connection">
                                            <TfiLock /> {t('contact-page.contact-form-text-bottom')}
                                        </p>
                                    </Col>
                                </Row>
                            </form>
                        </Tab>
                    </Tabs>
                </Col>
                <Col lg={5} md={12} xs={12}>
                    <div className="contact-us-support-wrapper">
                        <article className="contact-us-support-text">
                            <h2>
                                <TfiHelpAlt />
                                {t('contact-page.contact-support-title')}
                            </h2>
                            <p>{t('contact-page.contact-support-text')}</p>
                        </article>
                        <div className="contact-us-support-links">
                            <Nav.Link
                                href={`${isFR ? 'https://obambu.com/aide/categorie/hebergement-web/' : 'https://obambu.com/help/'}`}
                                rel="noopener noreferrer"
                            >
                                <h3>{t('contact-page.contact-support-title-1')}</h3>
                                <p>{t('contact-page.contact-support-text-1')}</p>
                                <FaAngleRight />
                            </Nav.Link>
                            <Nav.Link
                                href={`${isFR ? 'https://obambu.com/aide/categorie/nom-de-domaine/' : 'https://obambu.com/help/'}`}
                                rel="noopener noreferrer"
                            >
                                <h3>{t('contact-page.contact-support-title-2')}</h3>
                                <p>{t('contact-page.contact-support-text-2')}</p>
                                <FaAngleRight />
                            </Nav.Link>
                            <Nav.Link
                                href={`${isFR ? 'https://obambu.com/aide/categorie/serveur-vps/' : 'https://obambu.com/help/'}`}
                                rel="noopener noreferrer"
                            >
                                <h3>{t('contact-page.contact-support-title-3')}</h3>
                                <p>{t('contact-page.contact-support-text-3')}</p>
                                <FaAngleRight />
                            </Nav.Link>
                            <Nav.Link
                                href={`${isFR ? 'https://obambu.com/aide/categorie/divers/paiement-et-facturation/' : 'https://obambu.com/help/'}`}
                                rel="noopener noreferrer"
                            >
                                <h3>{t('contact-page.contact-support-title-4')}</h3>
                                <p>{t('contact-page.contact-support-text-4')}</p>
                                <FaAngleRight />
                            </Nav.Link>
                            <p className="all-prices-link">
                                <Nav.Link
                                    href={`https://obambu.com/${isFR ? 'aide/' : 'help/'}`}
                                    rel="noopener noreferrer"
                                >
                                    {t('contact-page.contact-support-see-all')}
                                </Nav.Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    );
}

export default ContactUsComponent;
